import { render, staticRenderFns } from "./TooFar.vue?vue&type=template&id=1c71859c&scoped=true"
import script from "./TooFar.vue?vue&type=script&lang=js"
export * from "./TooFar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c71859c",
  null
  
)

export default component.exports